import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FLAG_PRICING_ANNUAL_SAVING_NOTE } from '@/constants/growthbook-flags';
import { useAnnualDiscountPercent, useMonthlyPriceLabel } from '@/hooks/billing/useAnnualDiscountPercent';
import type { PricingCardProps } from './PricingCard';
export interface HighlightAnnualDiscountProps {
  /** Request-resolved currency — see useAnnualDiscountPercent. */
  serverCurrency?: PricingCardProps['currency'];
  type: PricingCardProps['type'];
}

/**
 * The saving line under the price. Inherits its type styles from the card's
 * price-detail line.
 */
export const HighlightAnnualDiscount = ({
  serverCurrency,
  type
}: HighlightAnnualDiscountProps) => {
  // Free has no paid price to save against.
  if (type === 'Free') {
    return null;
  }
  return <AnnualDiscountLine serverCurrency={serverCurrency} type={type} data-sentry-element="AnnualDiscountLine" data-sentry-component="HighlightAnnualDiscount" data-sentry-source-file="HighlightAnnualDiscount.tsx" />;
};
const AnnualDiscountLine = ({
  serverCurrency,
  type
}: HighlightAnnualDiscountProps & {
  type: Exclude<PricingCardProps['type'], 'Free'>;
}) => {
  const percent = useAnnualDiscountPercent(type, serverCurrency);
  const monthlyPrice = useMonthlyPriceLabel(type, serverCurrency);
  const showSaving = useFeatureIsOn(FLAG_PRICING_ANNUAL_SAVING_NOTE);
  if (showSaving) {
    return <span data-testid="annual-saving">
        <span className="font-semibold text-inline-link">
          Saving {percent}%
        </span>{' '}
        with yearly billing
      </span>;
  }
  return <span data-testid="annual-saving" data-sentry-component="AnnualDiscountLine" data-sentry-source-file="HighlightAnnualDiscount.tsx">
      Billed yearly, or monthly for {monthlyPrice}
    </span>;
};